import {
    INIT_SDK,
    USER_INFO,
    APPLY_LIST,
    SESSION_LIST,
    FRIEND_LIST,
    CHAT_LIST,
    SEND_CHAT,
    SEND_APPLY,
    SEND_AGREE,
    SEND_REJECT,
    SEND_ADD_HEALTH_DATA,
    SEND_MSG_RECEIPT
} from './mutation-type'
const SDK = require('SDK')
import { appKey } from '../config/env'

export default {
    [INIT_SDK](state, {
        account,
        token
    }) {
        state.nim = new SDK.NIM({
            debug: true || { api: 'info', style: 'font-size:14px;color:blue;background-color:rgba(0,0,0,0.1)' },
            appKey: appKey,
            account: account,
            token: token,
            onconnect: () => {},
            ondisconnected: onDisconnected,
            onloginportschange: onloginportschange,
            // 好友关系
            onfriends: onFriends,
            onsyncfriendaction: onSyncFriendAction,
            // 会话
            onsessions: onSessions,
            onupdatesession: onUpdateSession,
            // 消息
            onroamingmsgs: saveMsg,
            onofflinemsgs: saveMsg,
            onmsg: onMsg,
            // 系统通知
            onofflinesysmsgs: onOfflineSysMsgs,
            onsysmsg: onSysMsg,
            onupdatesysmsg: onUpdateSysMsg,
            onsysmsgunread: onSysMsgUnread,
            onupdatesysmsgunread: onUpdateSysMsgUnread,
            onofflinecustomsysmsgs: onOfflineCustomSysMsgs,
            oncustomsysmsg: onCustomSysMsg
        })
        function onDisconnected(msg) {
        }
        function onloginportschange(msg) {
            
        }
        function onMsg(msg) {
            addMsg(msg);
        }

        function onFriends(friends) {
            state.friendList = state.nim.mergeFriends(state.friendList, friends);
        }
        //同步添加好友操作
        function onSyncFriendAction(obj) {
            switch (obj.type) {
                case 'addFriend':
                    console.log('你在其它端直接加了一个好友' + obj.account + ', 附言' + obj.ps);
                    onAddFriend(obj.friend);
                    break;
                case 'applyFriend':
                    console.log('你在其它端申请加了一个好友' + obj.account + ', 附言' + obj.ps);
                    break;
                case 'passFriendApply':
                    console.log('你在其它端通过了一个好友申请' + obj.account + ', 附言' + obj.ps);
                    onAddFriend(obj.friend);
                    break;
                case 'rejectFriendApply':
                    console.log('你在其它端拒绝了一个好友申请' + obj.account + ', 附言' + obj.ps);
                    break;
                case 'deleteFriend':
                    console.log('你在其它端删了一个好友' + obj.account);
                    onDeleteFriend(obj.account);
                    break;
                case 'updateFriend':
                    console.log('你在其它端更新了一个好友', obj.friend);
                    onUpdateFriend(obj.friend);
                    break;
            }
        }
        function onAddFriend(friend) {
            state.friendList = state.nim.mergeFriends(state.friendList, friend);
        }

        function onSessions(sessions) {
            if (sessions.unread > 0 && sessions.to != account) {
                
                state.sessionList = state.nim.mergeSessions(state.sessionList, sessions);
            }
        }
        function onUpdateSession(session) {
            //如果是自己发布的消息，则不让更新自己的会话列表
            if(session && session.lastMsg.from != account) {
                if (session.unread > 0) {
                    state.sessionList = state.nim.mergeSessions(state.sessionList, session);
                }

            }
        }
        //收到离线和漫游消息
        function saveMsg(msgs) {
            msgs = msgs.msgs;
            addMsgs(msgs)

        }

        function addMsgs(msgs) {
            var user,item
            if (!Array.isArray(msgs)) {
              addMsg(msgs);
              return;
            }
            item = state.msgs
            for (var i = 0; i < msgs.length; i++) {
                user = (msgs[i].from === account ? msgs[i].to : msgs[i].from);

                if (!item["p2p-" + user]) {
                  item["p2p-" + user] = [];
                }
                item["p2p-" + user].push(msgs[i]);
            };
            state.chatList = item

          };
          function addMsg(msg) {
            var user,item={};
            item = state.msgs
            if (msg.scene === "p2p") {
               user = "p2p-" + (msg.from === account ? msg.to : msg.from);
              if (!item[user]) {
                item[user] = [];
              }
                item[user].push(msg)
              state.chatList = item
            }
          };

        function onSysMsg(sysMsg) {

            pushSysMsgs(sysMsg);
        }
        //离线系统通知
        function onOfflineSysMsgs(sysMsgs) {

            pushSysMsgs(sysMsgs);
        }
        function onSysMsgUnread(obj) {

            state.sysMsgUnread = obj;
        }
        function onUpdateSysMsg(sysMsg) {
            if (sysMsg.type != 'applyFriend') {
                pushSysMsgs(sysMsg);
            }
        }
        function pushSysMsgs(sysMsgs) {

            if (!Array.isArray(sysMsgs) && sysMsgs) {
                sysMsgs = [sysMsgs]
            }
            state.sysMsgs = sysMsgs
        }
        function onUpdateSysMsgUnread(obj) {

            state.sysMsgUnread = obj;
        }
        function onOfflineCustomSysMsgs(sysMsgs) {
        }
        function onCustomSysMsg(sysMsg) {
            state.newestData = JSON.parse(sysMsg.content).data
        }
    },
    [SEND_AGREE](state, sysMsg) {
        sysMsg.ps.content = '已同意添加'
        let sysMsgs = state.sysMsgs
        for (let i = 0; i < sysMsgs.length; i++) {

          if (sysMsgs[i]['from'] == sysMsg.from) {
            state.sysMsgs.splice(i, 1)
            i--
          }
        }
        state.nim.passFriendApply({
            idServer: sysMsg.idServer,
            account: sysMsg.from,
            ps: JSON.stringify(sysMsg.ps),
            done: passFriendApplyDone
        });
        
        function passFriendApplyDone(error, obj) {

          if (!error) {
            state.friendList = obj.friend
          }
        }
    },
    [SEND_REJECT](state, sysMsg) {
        // 假设 sysMsg 是通过回调 `onsysmsg` 收到的系统通知
        sysMsg.ps.content = '已拒绝'
        let sysMsgs = state.sysMsgs
        for (let i = 0; i < sysMsgs.length; i++) {
          if (sysMsgs[i]['from'] == sysMsg.from) {
            state.sysMsgs.splice(i, 1)
            i--
          }
        }
        state.nim.rejectFriendApply({
          idServer: sysMsg.idServer,
          account: sysMsg.to,
          ps: JSON.stringify(sysMsg.ps),
          done: rejectFriendApplyDone
        });
        
        function rejectFriendApplyDone(error, obj) {
            if(!error) {
                state.friendList = obj.friend
            }
          
        }
    },
    [SEND_MSG_RECEIPT](state, session) {
        //发送已读回执
        let sessions = state.sessionList
        let sid = session.id
        for (let i = 0; i < sessions.length; i++) {
            if(sessions[i]['id'] == sid) {
                sessions.splice(i, 1)
                i--
            }
        }
        state.sessionList = sessions
        state.nim.sendMsgReceipt({
          msg: session.lastMsg,
          done: function(err, obj) {
              if(!err) {
                  state.nim.resetSessionUnread(sid)
              }
          }
        });
    }

}


// WEBPACK FOOTER //
// ./src/store/mutations.js